import Modal from "../../components/Modal";
import PageHeader from "../../components/PageHeader";
import PageActions from "../../components/PageActions";
import Table from "../../components/Table";
import Badge from "../../components/Badge";
import FilterModal from "../../components/FilterModal";
import Pagination from "../../components/Pagination";

import UsuarioForm from "./components/UsuarioForm";

import { usuarioFilterFields } from "./constants/filterFields";

import { UsuarioProvider, useUsuario } from "./context/UsuarioContext";
import { useState } from "react";

import { createTableActions } from "../../utils/tableActions";

const UsuarioContent = () => {
  const {
    filters,
    filterErrors,
    usuarios,
    lojas,
    roles,
    isOpen,
    editingItem,
    isLoading,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    setCurrentPage,
    openModal,
    closeModal,
    handleFieldChange,
    handleSearch,
    handleClear,
    clearFilterErrors,
    handleSubmit,
    handleEdit,
    handleDelete,
  } = useUsuario();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const activeFiltersCount = Object.values(filters).filter(
    (value) => value !== null && value !== undefined && value !== ""
  ).length;

  const tableActions = createTableActions(handleEdit, handleDelete);

  const filterFields = usuarioFilterFields.map((field) => {
    const baseField = {
      ...field,
      value: filters[field.name as keyof typeof filters] || "",
    };

    if (field.name === "lojaId") {
      return {
        ...baseField,
        options: lojas.map((loja) => ({ value: loja.id, label: loja.nome })),
      };
    }

    if (field.name === "roleId") {
      return {
        ...baseField,
        options: roles.map((role) => ({ value: role.id, label: role.nome })),
      };
    }

    return baseField;
  });

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Gerenciar Usuários"
          description="Aqui você pode administrar todos os usuários do sistema"
        />
        <PageActions
          onFilter={() => setIsFilterModalOpen(true)}
          onAdd={() => openModal()}
          addButtonText="Novo Usuário"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="overflow-x-auto pb-4">
        <div className="min-w-max">
          <Table
            headers={["Nome", "Email", "Loja", "Cargo", "Status"]}
            data={usuarios.map((usuario) => [
              usuario.nome,
              usuario.email,
              usuario.loja?.nome || "-",
              usuario.role?.nome ? (
                <Badge
                  variant={
                    usuario.role.nome.toLowerCase().includes("admin")
                      ? "admin"
                      : "user"
                  }
                >
                  {usuario.role.nome}
                </Badge>
              ) : (
                "-"
              ),
              usuario.ativo ? "Ativo" : "Inativo",
            ])}
            actions={tableActions}
          />
        </div>
      </div>

      {totalPages > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => {
          clearFilterErrors();
          setIsFilterModalOpen(false);
        }}
        fields={filterFields}
        errors={filterErrors}
        onFieldChange={handleFieldChange}
        onSearch={() => {
          if (handleSearch()) setIsFilterModalOpen(false);
        }}
        onClear={handleClear}
      />

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={editingItem ? "Editar Usuário" : "Novo Usuário"}
      >
        {isOpen && (
          <UsuarioForm
            initialData={editingItem || undefined}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            isLoading={isLoading}
          />
        )}
      </Modal>
    </main>
  );
};

const Usuario = () => {
  return (
    <UsuarioProvider>
      <UsuarioContent />
    </UsuarioProvider>
  );
};

export default Usuario;
